import React from 'react';
import { Modal, Button } from 'antd';
import deleteIcon from 'assets/images/delete-Icon.svg';
import './index.css';

const ConfirmModal = ({
	visible,
	onCancel,
	onConfirm,
	title = 'Confirm to Delete',
	content = 'Are you sure you want to delete this item?',
	contentElement = null,
	showIcon = true,
	showFooter = true,
	width = 640,
	showDefaultTitle = false,
	confirmButtonText = 'Confirm'
}) => {
	return (
		<Modal
			title={showDefaultTitle ? title : null}
			open={visible}
			onCancel={onCancel}
			width={width}
			centered
			footer={null}
			closable={true}
			closeIcon={<img src={require('assets/images/closeBtn.png')} className="app-modal-close-btn" />}
			styles={{
				body: {
					padding: '32px 24px',
					textAlign: 'center',
				},
			}}
		>
			<div className="modal-section-delete">
				{showIcon && <div>
					<img src={deleteIcon} alt="" />
				</div>}
				{!showDefaultTitle && <div className="modal-section-delete-text">{title}</div>}
				<div>
					<div className="modal-section-delete-sub-text">{contentElement ?? content}</div>
				</div>
				{showFooter && (
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
							gap: '12px',
							marginTop: '24px',
						}}
					>
						<Button key="cancel" color="default" onClick={onCancel}>
							Cancel
						</Button>
						<Button color="purple" variant="solid" onClick={onConfirm}>
							{confirmButtonText || 'Confirm'}
						</Button>
					</div>
				)}
				
			</div>
		</Modal>
	);
};

export default ConfirmModal;
